// Session times: the owner types Baghdad wall-clock (UTC+3, no DST); booking
// stores UTC instants. Pure.

const BAGHDAD_MS = 3 * 60 * 60 * 1000;

function parseHHMM(hhmm: string): [number, number] | null {
  const m = /^(\d{1,2}):(\d{2})$/.exec(hhmm);
  if (!m) return null;
  const h = Number(m[1]);
  const min = Number(m[2]);
  return h > 23 || min > 59 ? null : [h, min];
}

/**
 * The next `weekday` (0 = Sunday … 6 = Saturday, Baghdad) at `hhmm` Baghdad,
 * strictly after `now`, as an ISO UTC instant. Today counts while the time is
 * still ahead.
 */
export function nextWeekdayAt(weekday: number, hhmm: string, now: Date = new Date()): string {
  const t = parseHHMM(hhmm);
  if (!t) return '';
  const local = new Date(now.getTime() + BAGHDAD_MS); // Baghdad wall-clock read through the UTC getters
  const base = Date.UTC(local.getUTCFullYear(), local.getUTCMonth(), local.getUTCDate(), t[0], t[1]) - BAGHDAD_MS;
  let days = (weekday - local.getUTCDay() + 7) % 7;
  if (days === 0 && base <= now.getTime()) days = 7;
  return new Date(base + days * 86_400_000).toISOString();
}

/** 'YYYY-MM-DD' + 'HH:MM' Baghdad → ISO UTC instant ('' when malformed). */
export function baghdadAt(date: string, hhmm: string): string {
  const d = /^(\d{4})-(\d{2})-(\d{2})$/.exec(date);
  const t = parseHHMM(hhmm);
  if (!d || !t) return '';
  return new Date(Date.UTC(Number(d[1]), Number(d[2]) - 1, Number(d[3]), t[0], t[1]) - BAGHDAD_MS).toISOString();
}

/** An instant → its Baghdad {weekday, 'HH:MM', 'YYYY-MM-DD'}. */
export function inBaghdad(iso: string): { weekday: number; hhmm: string; date: string; day: number; month: number } {
  const l = new Date(Date.parse(iso) + BAGHDAD_MS);
  const pad = (n: number) => String(n).padStart(2, '0');
  return {
    weekday: l.getUTCDay(),
    hhmm: `${pad(l.getUTCHours())}:${pad(l.getUTCMinutes())}`,
    date: `${l.getUTCFullYear()}-${pad(l.getUTCMonth() + 1)}-${pad(l.getUTCDate())}`,
    day: l.getUTCDate(),
    month: l.getUTCMonth(),
  };
}
